<template>
  <div>
    <b-modal id="popup-modal"
             v-if="popup"
             size="md"
             title=""
             hide-header
             centered>
      <div class="">
        <div class="text-right pb-1">
          <a class="close-svg"
             @click="$bvModal.hide('popup-modal')">
            <CloseSvg/>
          </a>
        </div>
        <div class="mt-2 d-flex flex-column gap-20">
          <div v-if="popup.image"
               class="text-center">
            <img :src="popup.image"
                 class="popup-img"
                 alt=""/>
          </div>
          <div v-if="!popup.image"
               class="text-center">
            <InfoSvg/>
          </div>
          <div v-if="popup.youtubeUrl">
            <iframe :src="popup.youtubeUrl"
                    allowfullscreen></iframe>
          </div>
          <div v-if="popup.title"
               class="text-center">
            <h3 class="mb-0">{{ popup.title }}</h3>
          </div>
          <article class="text-center"
                   v-html="popup.text"
                   v-if="popup.text"/>
        </div>
      </div>
      <template #modal-footer>
        <div class="modal-footer-buttons border-top w-100 pt-4">
          <div class="row no-gutters align-items-center justify-content-end">
            <!--            <div class="col-sm-auto col-6 order-sm-0 order-1">-->
            <!--              <b-button class="cancel w-auto px-md-3 px-2 sec-button see-later"-->
            <!--                        variant="themed"-->
            <!--                        @click="close()">-->
            <!--                {{ $t('see_later') }}-->
            <!--              </b-button>-->
            <!--            </div>-->
            <div class="col-sm-auto col-12 order-sm-1 order-2">
              <b-button class="cancel ml-sm-3 ml-0 w-auto px-md-3 px-2 sec-button do-not-show"
                        variant="themed"
                        @click="doNotShowAnymore">
                {{ $t('do_not_show_anymore') }}
              </b-button>
            </div>
            <div class="mb-sm-0 mb-2 col-sm-auto col-12 order-sm-2 order-0">
              <a v-if="popup.url"
                 :href="popup.url"
                 @click="doNotShowAnymore"
                 target="_blank"
                 class="ml-sm-3 ml-0 btn-themed btn px-md-3 px-2 w-auto main-button">
                {{ popup.button_title ? popup.button_title : $t('follow') }}
              </a>
            </div>
          </div>

        </div>
      </template>
    </b-modal>
  </div>
</template>

<script setup>
import { ClinicService } from "@/services/api/clinic.api.service"
import CloseSvg from '@/assets/svg-vue/general/close3.svg'
import InfoSvg from '@/assets/svg-vue/general/info3.svg'
import { getCurrentInstance, nextTick, onBeforeMount, onMounted, ref} from "vue"

const popup = ref(null)
let bvModal = null

const checkPopup = async () => {
  try {
    const res = await ClinicService.getPopup()
    if(res?.data?.id) {
      const alreadyWatched = window.localStorage.getItem(`viewedPopup${res.data.id}`) ?? false
      if(!alreadyWatched) {
        popup.value = res.data
        await nextTick()
        bvModal.show('popup-modal')
      }
    }
  } catch (e) {
    console.error(e)
  }
}

const doNotShowAnymore = () => {
  window.localStorage.setItem(`viewedPopup${popup.value.id}`, true)
  bvModal.hide('popup-modal')
}

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.proxy?.$bvModal
})

onMounted(() => {
  checkPopup()
})
</script>

<style scoped lang="scss">
.popup-img {
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 16px;
}
.gap-20 {
  gap: 20px;
}
iframe {
  width: 100%;
  height: 350px;
}
.close-svg {
  svg {
    width: 30px;
    height: 30px;
    fill: $gray-text;
    cursor: pointer;
    opacity: 0.7;
  }
  &:hover {
    svg {
      opacity: 1;
    }
  }
}
@media screen and (min-width: 992px) {
  .main-button, .do-not-show {
    min-width: 180px !important;
  }
}

@media screen and (max-width: 576px) {
  .main-button, .do-not-show {
    width: 100% !important;
    height: 36px !important;
  }
}
</style>
